/* ============================================================
   AŞKIM: size and colour logic
   Works out which variant a choice points at, and which sizes (or
   colours) are sold out or were never made, given the other choice.
   Variants are shaped like Shopify's `product.variants | json`.
   Loaded as a plain script in the browser (window.AskimVariants) and as
   a module by the tests.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AskimVariants = api;
})(this, function () {

  function sameOptions(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  /* The variant whose options equal `selected` exactly, or null. */
  function findVariant(variants, selected) {
    for (var i = 0; i < variants.length; i++) {
      if (sameOptions(variants[i].options, selected)) return variants[i];
    }
    return null;
  }

  /* Every value of option `index`, in the order the admin lists them, with
     whether a variant exists for it given the other selections, and whether
     that variant can still be bought. An unset selection (null) matches
     anything. */
  function optionStates(variants, selected, index) {
    var order = [], seen = {};
    variants.forEach(function (v) {
      var value = v.options[index];
      if (!seen[value]) { seen[value] = true; order.push(value); }
    });
    return order.map(function (value) {
      var matches = variants.filter(function (v) {
        if (v.options[index] !== value) return false;
        for (var j = 0; j < v.options.length; j++) {
          if (j === index) continue;
          if (selected[j] !== null && selected[j] !== undefined && v.options[j] !== selected[j]) return false;
        }
        return true;
      });
      return {
        value: value,
        exists: matches.length > 0,
        available: matches.some(function (v) { return v.available; })
      };
    });
  }

  /* Colours are judged on their own: a colour can be bought if any of its
     sizes can. Judging a colour against the chosen size made colours that
     come in other sizes look sold out or missing. */
  function colourStates(variants, index) {
    var none = variants.length ? variants[0].options.map(function () { return null; }) : [];
    return optionStates(variants, none, index);
  }

  /* The variant a click on option `index` = `value` should land on: the
     exact combination if it exists, otherwise the first one with that value
     that can still be bought, otherwise the first one with that value. */
  function resolveChoice(variants, selected, index, value) {
    var next = selected.slice(); next[index] = value;
    var exact = findVariant(variants, next);
    if (exact) return exact;
    var withValue = variants.filter(function (v) { return v.options[index] === value; });
    return withValue.filter(function (v) { return v.available; })[0] || withValue[0] || null;
  }

  /* The photographs to show for a chosen colour, as media ids in admin
     order. Photos sit in colour groups: a colour's own photo (its variant
     image) starts its group, and every photo after it belongs to that
     colour until the next colour's photo. Photos before any group are
     shared and follow the chosen colour's own. When the choice cannot be
     read that way (one colour, no colour option, a colour without a photo
     of its own) nothing is hidden. `media` is [{ id, position }] in any
     order. */
  function galleryPlan(media, variants, colourIndex, colour) {
    var sorted = media.slice().sort(function (a, b) { return a.position - b.position; });
    var all = sorted.map(function (x) { return String(x.id); });
    if (colourIndex < 0) return all;

    /* A colour's own photo only counts if it is one of the photos here (a
       film as the variant image is not), and two colours may share one. */
    var startOf = {}, startsAt = {}, colours = [];
    variants.forEach(function (v) {
      var c = v.options[colourIndex];
      if (colours.indexOf(c) < 0) colours.push(c);
      var id = v.featured_media ? String(v.featured_media.id) : null;
      if (id && !(c in startOf) && all.indexOf(id) >= 0) {
        startOf[c] = id;
        (startsAt[id] = startsAt[id] || []).push(c);
      }
    });
    if (colours.length < 2 || !(colour in startOf)) return all;

    var groupOf = {}, current = null;
    all.forEach(function (id) {
      if (startsAt[id]) current = startsAt[id];
      groupOf[id] = current;
    });
    var own = all.filter(function (id) { return groupOf[id] && groupOf[id].indexOf(colour) >= 0; });
    var shared = all.filter(function (id) { return groupOf[id] === null; });
    /* Never an empty gallery, whatever the admin holds. */
    return own.length ? own.concat(shared) : all;
  }

  return { findVariant: findVariant, optionStates: optionStates, colourStates: colourStates, resolveChoice: resolveChoice, galleryPlan: galleryPlan };
});
